import React from "react";
import "./CopyRight.css";

function CopyRight() {
	return (
		<div className="footerBottom">
			<p>
				Copyright &copy; 2024; Designed By
				<span className="designer"> Mert Can Caglayan</span>
			</p>
		</div>
	);
}

export default CopyRight;
